'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
var MaterialDrop = require('../MaterialDrop/MaterialDrop.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-mini',
    cnInteractive = "".concat(CLASSNAME, "--interactive"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnSubline = "".concat(CLASSNAME, "__subline");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function TeaserMini(_ref) {
  var className = _ref.className,
      iconId = _ref.iconId,
      link = _ref.link,
      onClick = _ref.onClick,
      subline = _ref.subline,
      title = _ref.title,
      type = _ref.type;

  var Content = function Content() {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconId && /*#__PURE__*/React__default.createElement(Icon, {
      id: iconId,
      size: "md",
      className: cnIcon
    }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h4", {
      className: cnTitle
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: cnSubline
    }, subline), !!(link || onClick) && /*#__PURE__*/React__default.createElement(MaterialDrop, null)));
  };

  var classes = classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnInteractive, !!(link || onClick)), "".concat(CLASSNAME, "--").concat(type));

  if (link) {
    return /*#__PURE__*/React__default.createElement(Link, {
      className: classes,
      onClick: onClick,
      link: link
    }, /*#__PURE__*/React__default.createElement(Content, null));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes,
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement(Content, null));
}
TeaserMini.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Icon */
  iconId: PropTypes.string,

  /** Simple link string */
  link: PropTypes.string,

  /** Action on click */
  onClick: PropTypes.func,

  /** */
  subline: PropTypes.string.isRequired,

  /** */
  title: PropTypes.string.isRequired,

  /** */
  type: PropTypes.oneOf(['primary', 'secondary'])
};
TeaserMini.defaultProps = {
  type: 'primary'
};

module.exports = TeaserMini;
